module.exports = __webpack_public_path__ + "img/zc-06.6f3d745f.svg";